import { theme } from '@config/theme';
import { OfferTypeViewPage } from '@features/specialistOffer/offerTypeView/OfferTypeView';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import { useMediaQuery } from '@mui/material';

export const ViewOffers = () => {
	const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
	useAppbarTitle(isMobile ? 'requestsOffers' : 'viewRequestsOffers');

	return <OfferTypeViewPage />;
};
